import type { SubNavigationLink } from '@ctw/shared/components/navigation/sub-navigation-bar';

/**
 * Prefix a sub-navigation `href` with `basePath` so it is always absolute
 * (`<basePath>/<section>`).
 *
 * Relative hrefs resolve against the current path, so links are prefixed
 * with the section base.
 *
 * Already-absolute hrefs are returned unchanged, keeping this idempotent.
 */
const prefixHref = (href: string, basePath: string): string =>
  href.startsWith('/') ? href : `${basePath}/${href}`;

export const withRoutePrefix = (
  subNavigationLinks: Array<SubNavigationLink>,
  basePath: string,
): Array<SubNavigationLink> =>
  subNavigationLinks.map((link) => ({
    ...link,
    href: prefixHref(link.href, basePath),
    siblingHrefs: link.siblingHrefs?.map((siblingHref) => prefixHref(siblingHref, basePath)),
  }));
